var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "send-box-container" },
    [
      _vm.hasReplyTo
        ? _c("div", { staticClass: "pt-2 pb-2 d-flex w-100" }, [
            _c(
              "div",
              { staticClass: "w-100" },
              [
                _c("i", { staticClass: "fas fa-reply mr-3" }),
                _vm._v(" "),
                _c(
                  "el-tooltip",
                  {
                    attrs: {
                      content: "Click to highlight a message",
                      placement: "top",
                      effect: "light",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "font-weight-bold",
                        attrs: { href: _vm.getReplyToHref },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.scrollToMessage.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.getSubject) + "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "ml-3 cursor-pointer",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.removeReplyTo.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("el-input", {
        ref: "subject",
        staticClass: "send-box__subject",
        attrs: { placeholder: "Subject" },
        scopedSlots: _vm._u([
          {
            key: "append",
            fn: function () {
              return [
                _c(
                  "email-placeholder",
                  { on: { select: _vm.addPlaceholderToSubject } },
                  [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Placeholders", placement: "top" } },
                      [
                        _c(
                          "span",
                          { staticClass: "color--prpl cursor-pointer" },
                          [_c("i", { staticClass: "fas fa-code" })]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.subject,
          callback: function ($$v) {
            _vm.subject = $$v
          },
          expression: "subject",
        },
      }),
      _vm._v(" "),
      !_vm.hasEmailAddress
        ? _c(
            "el-select",
            {
              staticClass: "send-box__subject w-100 mt-1",
              attrs: { filterable: "", placeholder: "From" },
              model: {
                value: _vm.email_address_id,
                callback: function ($$v) {
                  _vm.email_address_id = $$v
                },
                expression: "email_address_id",
              },
            },
            _vm._l(_vm.getEmailList, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "send-box send-box__editor d-flex mt-1",
          style: _vm.styles,
        },
        [
          _c(
            "el-scrollbar",
            {
              staticClass: "flex-grow-1",
              attrs: { native: false, wrapClass: "no-scroll-x" },
            },
            [
              _c("tinymce-editor", {
                ref: "textarea",
                staticClass: "content",
                model: {
                  value: _vm.body,
                  callback: function ($$v) {
                    _vm.body = $$v
                  },
                  expression: "body",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "send-button",
              attrs: { disabled: !_vm.canSend },
              on: { click: _vm.send },
            },
            [_c("i", { staticClass: "fas fa-paper-plane" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "email-placeholder",
        { on: { select: _vm.addPlaceholderToBody } },
        [
          _c(
            "el-tooltip",
            { attrs: { content: "Placeholders", placement: "top" } },
            [
              _c("span", { staticClass: "color--prpl cursor-pointer" }, [
                _c("i", { staticClass: "fas fa-code" }),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }